import { makeAutoObservable } from 'mobx';

// Cap dismiss memory across long sessions that touch many threads. Entries
// are also auto-cleared when the turn advances (see `isDismissed`).
const MAX_TRACKED_DISMISSALS = 200;

class TodoPlanDismissStore {
  private dismissedAtUserMessageId = new Map<string, string>();

  constructor() {
    makeAutoObservable<this, 'dismissedAtUserMessageId'>(this, {
      dismissedAtUserMessageId: true,
    });
  }

  // Pure read — never mutates. Stale entries are evicted by `dismiss`'s LRU
  // cap, not from a render-time delete (mutating observable state during
  // render is brittle under React Strict Mode).
  isDismissed(threadId: string, latestUserMessageId: string | null): boolean {
    if (!latestUserMessageId) return false;
    return this.dismissedAtUserMessageId.get(threadId) === latestUserMessageId;
  }

  dismiss(threadId: string, latestUserMessageId: string | null): void {
    if (!latestUserMessageId) return;
    this.dismissedAtUserMessageId.delete(threadId);
    this.dismissedAtUserMessageId.set(threadId, latestUserMessageId);
    if (this.dismissedAtUserMessageId.size > MAX_TRACKED_DISMISSALS) {
      const oldest = this.dismissedAtUserMessageId.keys().next().value;
      if (oldest !== undefined) {
        this.dismissedAtUserMessageId.delete(oldest);
      }
    }
  }
}

export const todoPlanDismissStore = new TodoPlanDismissStore();
